<template>
  <v-container align-start ma-0 mt-15 pa-0 about-bi>
    <v-row no-gutters class="justify-center content-bottom">
      <v-col cols="12" class="contents-width mt-15">
        <v-row no-gutters>
          <v-col cols="12" class="pa-0 text-center">
            <span class="font-size-title-sm font-weight-bold">{{ section1.title }}</span>
            <v-col class="pa-0 mt-6">
              <template v-for="(text, text_index) in section1.text">
                <p :key="text_index" class="mb-1 font-size-md font-weight-regular">{{ text }}</p>
              </template>
            </v-col>
            <v-col class="pa-0 mt-10 about-section-svg p-relative">
              <svg-icon icon-class="grid" class="about-svg-grid" alt="" />
              <svg-icon icon-class="goseong_logo" class="about-svg-logo p-absolute" alt="" />
            </v-col>
            <v-col class="pa-0 mt-10">
              <template v-for="btn in section1.btn">
                <v-btn
                  :key="btn.id"
                  width="230"
                  height="60"
                  elevation="0"
                  outlined
                  class="font-size-md font-weight-medium rounded-none btn-ltr-mask about-section1-btn"
                  :class="btn.class"
                  @click="download(btn.id)"
                >
                    {{ btn.text }}
                  <svg-icon icon-class="download" class="ml-4 about-section1-btn-svg" alt="" />
                </v-btn>
              </template>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="contents-width about-section2">
        <v-row no-gutters>
          <v-col cols="12" class="pa-0 text-center">
            <span class="font-size-title-sm font-weight-bold">{{ section2.title }}</span>
            <v-col class="pa-0 mt-15">
              <v-row no-gutters justify="center" class="mx-4">
                <template v-for="(color, color_index) in section2.list">
                  <v-col :key="color.id" :cols="color.cols" class="pa-0 text-start" :class="color_index == 0 ? 'mr-4' : ''">
                    <span class="font-size-lg font-weight-bold">{{ color.id }}</span>
                    <v-row no-gutters class="mt-5 justify-space-between">
                      <template v-for="card in color.list">
                        <v-col :key="card.hex" class="pa-0">
                          <v-card 
                            height="145"
                            width="145"
                            :color="card.hex"
                            class="pa-2 rounded-none d-flex align-end justify-end"
                          >
                            <span class="white--text font-weight-regular">{{ card.hex }}</span>
                          </v-card>
                          <v-col class="pa-0 mt-5">
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">R</b>{{ card.r }}</span>
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">G</b>{{ card.g }}</span>
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">B</b>{{ card.b }}</span>
                          </v-col>
                          <v-col class="pa-0">
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">C</b>{{ card.c }}</span>
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">M</b>{{ card.m }}</span>
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">Y</b>{{ card.y }}</span>
                            <span class="mr-2 sub_title--text font-weight-light font-size-md"><b class="mr-1 font-weight-bold">K</b>{{ card.k }}</span>
                          </v-col>
                        </v-col>
                      </template>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="contents-width about-section3">
        <v-row no-gutters>
          <v-col cols="12" class="pa-0 text-center">
            <span class="font-size-title-sm font-weight-bold">{{ section3.title }}</span>
            <v-col class="pa-0 mt-15 p-relative">
              <v-col class="pa-0 mt-10 about-section-svg p-relative">
                <svg-icon icon-class="grid2" class="about-svg-grid" alt="" />
              </v-col>
              <v-row no-gutters class="p-absolute about-section3-logo">
                <template v-for="(svg) in section3.list">
                  <v-col :key="svg.svg" class="pa-0 mt-10 p-relative">
                    <svg-icon :icon-class="svg.svg" class="p-absolute" :class="svg.svg" alt="" />
                    <v-col class="pa-3 pb-0 p-absolute about-section3-text">
                      <span class="sub_title--text font-weight-light">{{ svg.text }}</span>
                    </v-col>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { downloadServerFile } from '@/framework/system/file/file_api.js'
import SvgIcon from '@/components/svgicon';

export default {
  name: 'AboutBi',
  components: {
    SvgIcon,
  },
  data() {
    return {
      section1: {
        title: '로고마크 Logomark',
        text: [
          '경남 고성시장의 로고마크는 다방면의 커뮤니케이션에 있어서 고성시장만의 이미지를 대표하는 가장 중요한 요소입니다.',
          '전통시장의 고유한 분위기를 캘리그라피 디자인으로 표현하고, it 기술을 접목하여 새로운 도전을 시작하는',
          '고성시장의 현대적이고 세련된 무드를 나타내는 컬러 조합으로 고성시장만의 특별한 로고마크입니다.'
        ],
        btn: [
          { id: 5, text: 'AI파일 다운로드', class: 'mr-2' },
          { id: 4, text: 'PNG파일 다운로드', class: 'ml-2' },
        ]
      },
      section2: {
        title: '색상 Color System',
        list: [
          { id: 'Primary Color', cols: 2, list: [{ hex: '#000000', r: 0, g: 0, b: 0, c: 0, m: 0, y:0, k:100 }] },
          { id: 'Secondary Colors',
            cols: 8,
            list: [
              { hex: '#14294E', r: 21, g: 41, b: 78, c: 100, m: 95, y: 50, k: 25 },
              { hex: '#E3806E', r: 227, g: 129, b: 112, c: 10, m: 50, y: 60, k: 0 },
              { hex: '#B787BA', r: 184, g: 135, b: 186, c: 35, m: 55, y: 5, k: 0 },
              { hex: '#2999DA', r: 41, g: 153, b: 218, c: 75, m: 30, y: 5, k: 0 },
            ]
          },
        ]
      },
      section3: {
        title: '시그니처 Signature',
        list: [
          { svg: 'goseong_logo_2', text: '세로 조합' },
          { svg: 'goseong_logo_3', text: '가로 조합' },
        ]
      },
    }
  },
  created() {},
  mounted() {
    
  },
  methods: {
    download(param) {
      downloadServerFile({ id: param, type: 'bi' })
        .then(res => {
          if(res.success) {
            const path = res.map.file_path + res.map.file_desc
            const link = document.createElement('a')
            link.href = path
            link.download = res.map.file_desc
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.about-bi {
  .about-section-svg {
    width: 100%;
    height: 350px;
    .about-svg-grid {
      width: 100%;
      height: 350px !important;
    }
    .about-svg-logo {
      left: 50%;
      top: 50%;
      height: 200px;
      transform: translate(-50%, -50%);
    }
  }
  .about-section1-btn-svg {
    width: 17px !important;
    height: 17px !important;
  }
  .about-section2,
  .about-section3 {
    margin-top: 200px;
  }
  .about-section3-logo {
    top: 0;
    width: 100%;
    height: 100%;
    .goseong_logo_2 {
      left: 50%;
      top: 50%;
      height: 170px;
      transform: translate(-50%, -50%);
    }
    .goseong_logo_3 {
      left: 50%;
      top: 50%;
      height: 100px;
      transform: translate(-50%, -50%);
    }
    .about-section3-text {
      bottom: -15%;
    }
  }
}

</style>
